export default "__VITE_ASSET__0c982772__"